import { render, staticRenderFns } from "./ValueChangeIcon.vue?vue&type=template&id=160833fa&scoped=true&"
import script from "./ValueChangeIcon.vue?vue&type=script&lang=js&"
export * from "./ValueChangeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ValueChangeIcon.vue?vue&type=style&index=0&id=160833fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160833fa",
  null
  
)

component.options.__file = "ValueChangeIcon.vue"
export default component.exports